import { SheetSectionCard } from '@/components/SheetSectionCard'
import { Skeleton } from '@/components/ui/skeleton'
import { CLIENT_VISIT_MIX_LIMIT } from '@/config/constants'
import type { ClientHistory } from '@/features/patients/hooks/useClientHistory'
import { visitMix } from '@/features/patients/utils/clientHistory'

/** The client's visits by type: what kind of care they actually receive. */
export function ClientVisitMix({
  visits,
}: {
  visits: ClientHistory['visits']
}) {
  if (!visits.allowed) return null
  const mix = visitMix(visits.rows).slice(0, CLIENT_VISIT_MIX_LIMIT)
  const top = mix[0]?.count ?? 0

  return (
    <SheetSectionCard
      title={
        visits.isLoading || visits.isError
          ? 'Visit mix'
          : `Visit mix · ${visits.rows.length}${visits.truncated ? '+' : ''} visits`
      }
      body={
        visits.isLoading ? (
          <Skeleton className="h-24 w-full" />
        ) : visits.isError || mix.length === 0 ? (
          <p className="text-muted-foreground py-2 text-center text-sm">
            {visits.isError ? 'Could not load visits' : 'No visits on file'}
          </p>
        ) : (
          <ul className="flex flex-col gap-2">
            {mix.map(({ type, count }) => (
              <li
                key={type}
                className="grid grid-cols-[minmax(0,10rem)_1fr_2rem] items-center gap-2.5 text-[13px]">
                <span className="truncate" title={type}>
                  {type}
                </span>
                <span className="bg-neutral-hover-bg h-1.5 overflow-hidden rounded-full">
                  <span
                    className="bg-primary-solid block h-full rounded-full"
                    style={{ width: `${(count / top) * 100}%` }}
                  />
                </span>
                <span className="text-muted-foreground text-right tabular-nums">
                  {count}
                </span>
              </li>
            ))}
          </ul>
        )
      }
    />
  )
}
